// Lightweight session store to carry analysis/match results between routes.
const K = {
  ANALYSIS: "moire.analysis",
  RESULT: "moire.result",
};

export const saveAnalysis = (data) => sessionStorage.setItem(K.ANALYSIS, JSON.stringify(data));
export const loadAnalysis = () => {
  try { return JSON.parse(sessionStorage.getItem(K.ANALYSIS)); } catch { return null; }
};
export const saveResult = (data) => sessionStorage.setItem(K.RESULT, JSON.stringify(data));
export const loadResult = () => {
  try { return JSON.parse(sessionStorage.getItem(K.RESULT)); } catch { return null; }
};
export const clearSession = () => { sessionStorage.removeItem(K.ANALYSIS); sessionStorage.removeItem(K.RESULT); };
